import Helper from "../../helper/helper";
import { exportTableToExcel } from "../../helper/fileExtensions";
import {RootStoreSingleton} from "../../stores/rootStore";

export const exportCsv = (columns, data) => {
    let managers = RootStoreSingleton.qarStore.allManagers.map((option) => ({
        id: option.id,
        firstName: option.firstName,
        secondName: option.secondName,
        surname: option.surname,
    }));
    let exportData = JSON.parse(JSON.stringify(data));
    exportData.forEach((rowData) => {
        let currentManager = managers.find(m => m.id === rowData.responsibleManagerId);
        rowData.firstName = [rowData.firstName, rowData.lastName].filter(e => e).join(' ');
        rowData.responsibleManagerId = currentManager ?
            [currentManager.firstName, currentManager.secondName, currentManager.surname]
                .filter(e => e).join(' ') : '';
    });
    exportTableToExcel(columns, exportData);
}

export const userColumns = [
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Employee Status",
        field: "enabled",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.enabled === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>,
    },
    {
        title: "Has Conflicts",
        field: "hasConflicts",
        type: 'boolean',
        grouping: false,
        render: rowData => <div className={rowData.hasConflicts === true ? "error-circle" : "checkmark"}><div>{rowData.hasConflicts === true ? "≠" : null}</div></div>
    }
];

export const userAccsColumns = [
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Is Active",
        field: "accountStatus",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.accountStatus === true ? <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>
    }
]

export const AllUserAccsColumns = [
    {
        title: "System User Name",
        field: "username",
    },
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Employee Status",
        field: "enabled",
        filtering: true,
        grouping: false,
        type: 'boolean',
        render: rowData => <>{rowData.enabled === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>
    },
    {
        title: "Account",
        field: "accountName",
    },
    {
        title: "Role Name",
        field: "roleName",
    },
    {
        title: "Has Admin Access",
        field: "isAdmin",
        type: 'boolean',
        filtering: true,
        grouping: false,
        render: rowData => <>{rowData.isAdmin === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Yes</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>No</span>}</>
    },
    {
        title: "Last Pass Reset",
        field: "lastPassResetDate",
        render: rowData => <>{Helper.parseDate(rowData.lastPassResetDate)}</>
    },
    {
        title: "Last Login",
        field: "lastLoginDate",
        render: rowData => <>{Helper.parseDate(rowData.lastLoginDate)}</>
    },
    {
        title: "Account Status",
        field: "isAccountActive",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.isAccountActive === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>
    }
]

export const UserWithoutRolesColumns = [
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Employee Status",
        field: "enabled",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.enabled === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>
    }
]

export const pgChangeColumns = [
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Title",
        field: "title",
    },
    {
        title: "Account",
        field: "permissionGroupAccount",
    },
    {
        title: "Permission Group",
        field: "permissionGroupName",
    },
    {
        title: "Action",
        field: "action",
        grouping: false,
        render: rowData => <>{rowData.action === "Added" ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Added</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Deleted</span>}</>
    },
    {
        title: "Change Date",
        field: "changeDate",
        grouping: false,
        render: rowData => <>{Helper.parseDate(rowData.changeDate)}</>
    },
]

export const UnmatchedEmployeesColumns = [
    {
        title: "Account",
        field: "accountName",
    },
    {
        title: "Username",
        field: "userName",
    },
    {
        title: "User",
        field: "firstName",
        render: rowData => <>{rowData.firstName} {rowData.lastName}</>,
        customFilterAndSearch: (term, rowData) => {
            const filter = term.toLowerCase();
            const fName = rowData.firstName ? rowData.firstName.toLowerCase() : rowData.firstName;
            const lName = rowData.lastName ? rowData.lastName.toLowerCase() : rowData.lastName;

            return (fName + ' ' + lName).indexOf(filter) !== -1;
        }
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Title",
        field: "jobTitle",
    },
    {
        title: "Description",
        field: "description",
        exportWidthInPx: 600,
    },
    {
        title: "Last Login",
        field: "lastLoginDate",
        render: rowData => <>{Helper.parseDate(rowData.lastLoginDate)}</>
    },
    {
        title: "Status",
        field: "isActive",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.isActive === true ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>,
    }
]

export const gcpColumns = [
    {
        title: "Employee Full Name",
        field: "fullName",
    },
    {
        title: "Title",
        field: "empTitle",
    },
    {
        title: "Employee Status",
        field: "status",
        type: 'boolean',
        grouping: false,
        render: rowData => <>{rowData.status === "Active" ? <span style={{ color: "green", "WebkitTextStroke": "0.1px black" }}>Active</span> : <span style={{ color: "red", "WebkitTextStroke": "0.1px black" }}>Inactive</span>}</>,
        customFilterAndSearch: (term, rowData) => {
            return term === 'checked' ?
            rowData.internal.status.indexOf("Active") !== -1 :
            rowData.internal.status.indexOf("Inactive") !== -1}
    }
]

export const pgsWithoutDescription = [
    {
        title: "Permission Group Name",
        field: "name",
    },
    {
        title: "Account Name",
        field: "accountName",
    }
]

export const qarFindingsColumns = [
    {
        title: "Employee Name",
        field: "fullName",
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Direct Manager",
        field: "managerFullName",
    },
    {
        title: "System",
        field: "systemName",
    },
    {
        title: "Account",
        field: "accountName",
    },
    {
        title: "Finding",
        field: "actionAsString",
    },
    {
        title: "Ticket ID",
        field: "ticketId",
    }
]

export const flagColors = {
    "0": "#169C39",
    "1": "#FFA500",
    "2": "#ff6666",
    "3": "grey"
}

export const ReportsMap = {
    'Intersection': "/intersection-report",
    'Employees Without Roles': "/users-without-roles-report",
    'All Employee Accounts': '/all-user-accounts-report',
    'Inactive Employee Accounts': '/inactive-user-accounts-report',
    'Permission Group Changes': '/permission-group-changes-report',
    'Not Recognized Users': '/unrecognized-users',
    'GCP Report': '/gcp-report',
    'Permission Groups Without Description': '/pgs-without-descriptions-report',
    'Password Never Expires Report': '/password-never-expires-report',
    'QAR Findings': '/qar-findings'
}

export const TableOptions = {
    search: true,
    paging: true,
    exportButton: true,
    exportCsv: exportTableToExcel,
    filtering: true,
    grouping: true,
    pageSize: 50,
    emptyRowsWhenPaging: false,
    pageSizeOptions: [10, 25, 50]
}

export const localization = {
    toolbar: {
        exportCSVName: "Export as XLSX",
    }
}

export const selectSize = [
    { value: "1000", label: "1000 rows" },
    { value: "2000", label: "2000 rows" },
    { value: "5000", label: "5000 rows" },
    { value: "10000", label: "10000 rows" }
];